<template>
  <div>
    <div class="section center">
      <div class="video-player">
        <iframe
          class="iframe-video"
          width="500"
          height="300"
          src="https://www.youtube.com/embed/yiTu-7O2vOg"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div
        class="text-slide"
        data-aos="fade-left"
        data-aos-duration="3000"
        ata-aos-easing="ease-in-sine"
      >
        Lave as mãos
      </div>
    </div>
    <div class="section center">
      <div class="center-info l-700">
        <div class="info info1">
          <div class="text">No estado de Santa Catarina, somente</div>
          <div class="number">
            <NumberCounter :from="0" :to="6" :duration="1"></NumberCounter
            >,<NumberCounter :from="0" :to="9" :duration="1"></NumberCounter>%
          </div>
          <div class="text">dos habeas corpus impetrados foram concedidos.</div>
          <div>
          <a
            class="link-fonte"
            href="http://defensoria.sc.def.br/wp-content/uploads/2021/04/CECADEP-O-STJ-e-os-pedidos-de-liberdade-na-pandemia-1-1.pdf"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        </div>
        <div class="info info2">
          <div class="text">No estado de São Paulo, apenas</div>
          <div class="number">
            8,<NumberCounter :from="1" :to="98" :duration="3"></NumberCounter>
          </div>
          <div class="text">dos habeas corpus impetrados foram concedidos.</div>
          <a
            class="link-fonte"
            href="https://www.scielo.br/j/rap/a/SQR9rkxTPjbLwsGFqh8CkBh/?lang=pt"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="info info3">
          <div class="text">
            Para ver outros relatórios de pesquisa sobre as decisões na
            pandemia, clique nos links abaixo.
            <br/>
            <br/>
             <a
            class="link-fonte"
            href="https://iddd.org.br/wp-content/uploads/2021/08/iddd-relatorio-negacionismo-final-2.pdf"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Link 1</span></a
          >
          <br/>
          <a
            class="link-fonte"
            href="https://www.covidnasprisoes.com/livro-covid-nas-prisoes"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Link 2</span></a
          >
          </div>
        </div>
      </div>
      <!-- <div>
        <a
          class="link-fonte margin-negativa-45"
          href="https://www.scielo.br/j/rap/a/SQR9rkxTPjbLwsGFqh8CkBh/?lang=pt"
          target="_blank"
          ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
        >
      </div> -->
    </div>
    <div class="section center">
      <div class="video-player">
        <iframe
          class="iframe-video"
          width="500"
          height="300"
          src="https://www.youtube.com/embed/trC_aaMgAfA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div
        class="text-slide"
        data-aos="fade-right"
        data-aos-duration="3000"
        ata-aos-easing="ease-in-sine"
      >
        Fome e Insalubridade
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.section {
  min-height: 100vh;
}

.center-info {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  display: flex;
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 70px 90px;
  column-gap: 40px;
  row-gap: 40px;
  overflow-x: auto;
}

.info {
  position: relative;

  .text {
    width: 145px;
    line-height: 1.1rem;
  }

  .number {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
}

.text-slide {
  position: absolute;
  font-size: 3.5rem;
  width: 800px;
  left: 20%;
  line-height: 4rem;
  font-family: Roboto Mono;
  font-style: normal;
  font-weight: 100;
  color: #d01c1f;
  top: 13%;

  &.right {
    text-align: right;
    left: initial;
    right: 20%;
  }
}

@media screen and (max-width: 480px) {
  .text-slide {
    font-size: 2rem;
    width: 200px;
    left: 10%;
    bottom: 5%;

    &.right {
      width: 250px;
      text-align: right;
      left: initial;
      right: 10%;
    }
  }

  .iframe-video {
    width: 100%;
    height: 200px;
  }
}
</style>
